// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow___9Khp","amount":"Amount_amount__2VH56","tip":"Amount_tip__3YQHS","tipHeader":"Amount_tipHeader__1rOau","tipsWrap":"Amount_tipsWrap__pdL1u"};